export default "__VITE_ASSET__DP9FrP7v__"